function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKTIME opcode — compare block timestamp to script constraint.
 */

module.exports = {
  name: 'CHECKTIME',
  description: 'Verify lastest block relative to timestamp.',
  exampleScript: {
    op: 'CHECKTIME',
    timestamp: '<timestamp>',
    operator: '<='
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object') {
      return false;
    }
    var timestampRaw = node.timestamp;
    if (timestampRaw === undefined || timestampRaw === null || timestampRaw === '') {
      return false;
    }
    var ts = Number(timestampRaw);
    if (!Number.isFinite(ts)) {
      return false;
    }
    return true;
  }
};